<template>
    <div>
        <!-- Alert: No item found -->
        <b-alert
            variant="danger"
            :show="!isLoading && campaign === null"
        >
            <div class="alert-body">
                Paylaşım Bulunamadı
                <b-link
                    class="alert-link"
                    :to="{ name: 'campaign' }"
                >
                    Paylaşım Raporları
                </b-link>
                sayfasını görüntüle
            </div>
        </b-alert>
        <loading-card v-if="isLoading"></loading-card>
        
        <div v-else-if="campaign !== null">
            <b-card
                no-body
                class="invoice-preview-card invoice-preview"
            >
                <!-- Header -->
                <b-card-body class="invoice-padding pb-0">
                    <div class="d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0">
                        <!-- Header: Left Content -->
                         <div class="d-flex">
                            <div class="auto mr-2" v-if="campaign.image">
                                <b-media
                                    v-b-popover.hover.right.html="popoverContent(campaign.image)"
                                    title="Paylaşım Görseli"
                                    custom-class="wide-popover"
                                >
                                    <img :src="imagePath+'/links/thumb/'+campaign.image" style="max-width: 150px;" v-if="campaign.image">
                                </b-media>
                            </div>
                            <div>

                                <div class="logo-wrapper">
                                    <h3 class="text-primary">
                                        {{ campaign.campaign_name || 'Paylaşım Adı Bulunamadı' }}
                                    </h3>
                                </div>
                                <b-col
                                    cols="12"
                                    class="p-0"
                                >
                                    <div>
                                        <table cellpadding="10">
                                            <tbody>
                                                <tr>
                                                    <td class="pr-1">Link:</td>
                                                    <td>
                                                        <span v-if="campaign.link">
                                                            <a :href="campaign.link" target="_blank" rel="noopener noreferrer">{{ campaign.link }}</a>
                                                        </span>
                                                        <span v-else>
                                                            Link Yok
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="pr-1">Kısa Link:</td>
                                                    <td v-if="campaign.short_url">
                                                        <a :href="campaign.short_url" target="_blank" rel="noopener noreferrer">{{ campaign.short_url }}</a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="pr-1">Uzun Link:</td>
                                                    <td v-if="campaign.short_data.long_url">
                                                        <a :href="campaign.short_data.long_url" target="_blank" rel="noopener noreferrer" style="word-break: break-word;">{{ campaign.short_data.long_url }}</a>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="pr-1">Paylaşım Türü:</td>
                                                    <td>{{ campaign.page_type }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table cellpadding="10" v-if="influencer.id!=1">
                                            <tbody>
                                                <tr class="text-danger" v-if="campaign.payment_amount">
                                                    <td class="pr-1">Ödeme Miktarı:</td>
                                                    <td class="font-weight-bold">
                                                        {{ campaign.payment_amount || 0 }}
                                                    </td>
                                                </tr>
                                                <tr class="text-success" v-if="!campaign.payment_amount">
                                                    <td class="pr-1">Link İçi Oran:</td>
                                                    <td class="font-weight-bold">
                                                        %{{ campaign.link_ici_odeme_orani || 0 }}
                                                    </td>
                                                </tr>
                                                <tr class="text-danger" v-if="!campaign.payment_amount">
                                                    <td class="pr-1">Link Dışı Oran:</td>
                                                    <td class="font-weight-bold">
                                                        %{{ campaign.link_disi_odeme_orani || 0 }}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td class="pr-1">Bağlı fenomen</td>
                                                    <td class="font-weight-bold">
                                                        <influencer-link-btn :id="influencer.id" :name="influencer.username" v-if="influencer.name_surname"/>
                                                        <span v-else>Fenomen Yok</span>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </b-col>
                            </div>
                        </div>

                        <!-- Header: Right Content -->
                        <div class="mt-md-0 mt-2">
                            <h4 class="invoice-title">
                                Paylaşım Secret ID:
                                <span class="invoice-number">
                                    #{{ campaign.secret_key || 'Bulunamadı' }}
                                </span>
                            </h4>
                            <div class="invoice-date-wrapper justify-content-end" v-if="influencer.id!=1">
                                <p class="invoice-date-title">Hakediş Süresi:</p>
                                <p class="invoice-date text-success">
                                    {{ influencer.vesting_period }} Gün
                                </p>
                            </div>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Başlangıç Tarihi:</p>
                                <p class="invoice-date" v-if="campaign.start_date">
                                    {{ formatDate(campaign.start_date) }}
                                </p>
                                <p class="invoice-date semibold text-danger" v-else>
                                    Tanımlanmamış
                                </p>
                            </div>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Bitiş Tarihi:</p>
                                <p class="invoice-date semibold" v-if="campaign.end_date">
                                    {{ formatDate(campaign.end_date) }}
                                </p>
                                <p class="invoice-date semibold text-danger" v-else>
                                    Tanımlanmamış
                                </p>
                            </div>
                            <div class="invoice-date-wrapper justify-content-end">
                                <p class="invoice-date-title">Durum:</p>
                                <p class="invoice-date semibold">
                                    <b-badge v-if="campaign.status" variant="success">Aktif</b-badge>
                                    <b-badge v-else variant="danger">Pasif</b-badge>
                                </p>
                            </div>
                        </div>
                    </div>
                </b-card-body>

                <!-- Spacer -->
                <hr class="invoice-spacing">

                <!-- Invoice Client & Payment Details -->
                <b-card-body
                    class="invoice-padding pt-0"
                >
                    <b-row class="invoice-spacing">
                        <!-- Col: Invoice To -->
                        <!-- <b-col
                            md="3"
                            xl="3"
                            class="p-0"
                        >   
                            <b-card-header>
                                <b-card-title>Atanan Fenomen</b-card-title>
                            </b-card-header>
                            <b-card-body class="pt-2 border-top">
                                <h6 class="mb-25">
                                    {{ influencer.name_surname || 'Fenomen Adı Yok' }}
                                </h6>
                                <p class="card-text mb-25">
                                    Kullanıcı Adı: {{ influencer.username || 'Yok' }}
                                </p>
                                <p class="card-text mb-25">
                                    Adı Soyad: {{ influencer.name_surname || 'Yok' }}
                                </p>
                                <p class="card-text mb-25">
                                    Unique Token: {{ influencer.unique_token || 'Token Yok' }}
                                </p>
                            </b-card-body>
                        </b-col> -->
                        <b-col
                            xl="12"
                            md="12"
                        >
                            <global-summary :linkId="campaign_id" />
                        </b-col>
                    </b-row>
                </b-card-body>
            </b-card>
            <!--  eski grafik
            <apex-line-area-chart 
                :link_id="campaign_id"
                :date-range-custom="{start: campaignStartDate, end: campaignEndDate}"
            />-->
            
            <echart-stacked-area
                :link_id="campaign_id"
                :date-range-custom="{start: campaignStartDate, end: campaignEndDate}"
            />

            <b-tabs
                v-if="influencer"
                pills
                >

                <!-- İlgili Siparişler -->
                <b-tab active>
                    <template #title>
                    <feather-icon
                        icon="ShoppingCartIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Siparişler</span>
                    </template>
                    <orders :tableColumns="tableColumns" :params="orderParams" @orders-fetched="handleOrdersFetched" :title="campaign.campaign_name+ ' Siparişleri'"></orders>
                </b-tab>
                <!-- İlgili ÜRünler -->
                <b-tab @click="isActiveTab='events'">
                    <template #title>
                    <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Tıklama Detayları</span>
                    </template>
                    <hourly-event v-if="isActiveTab === 'events' && campaign_id" :link_id="campaign_id" :title="campaign.campaign_name+ ' Saatlik Tıklamalar'"></hourly-event> 
                </b-tab>
                <!-- İlgili ÜRünler -->
                <b-tab @click="isActiveTab='products'">
                    <template #title>
                    <feather-icon
                        icon="InfoIcon"
                        size="16"
                        class="mr-0 mr-sm-50"
                    />
                    <span class="d-none d-sm-inline">Ürünler</span>
                    </template>
                    <products
                    v-if="isActiveTab === 'products' && campaign_id" :params="orderParams" :title="campaign.campaign_name+ ' Satılan ürünler'" ></products>
                </b-tab>

            </b-tabs>

        </div>
    </div>
</template>


<script>
    import { BRow, BAlert,BBadge,BCardTitle, BCol, BCard, BCardHeader, BCardBody, BTab, BTabs, BMedia, VBPopover } from 'bootstrap-vue';
    import LoadingCard from '@/layouts/components/isLoading.vue';
    import Orders from '../Orders.vue';
    import Products from '../Products.vue';
    import GlobalSummary from '@/components/GlobalSummary.vue';
    import HourlyEvent from '@/components/event/HourlyEvent.vue' // Import the hourly component
    import ApexLineAreaChart from '@/components/charts-components/ApexLineAreaChart.vue';
    import EchartStackedArea from '@/components/charts-components/EchartStackedArea.vue';
    import { getFinalPath } from '@core/utils/utils'
    import InfluencerLinkBtn from '@/components/link/InfluencerLinkBtn.vue'

    export default {
        components: {
            BTab, 
            BTabs,
            BRow,
            BCol,
            BCard,
            BCardHeader,
            BCardBody,
            BAlert,
            BBadge,
            BCardTitle,
            VBPopover,
            BMedia,

            LoadingCard,
            Orders,
            GlobalSummary,
            Products,
            HourlyEvent,
            ApexLineAreaChart,
            EchartStackedArea,
            InfluencerLinkBtn
        },
        directives: {
            'b-popover': VBPopover,
        },
        data() {
            return {
                campaign: null,
                isLoading : true,
                influencer: {},
                isActiveTab: {},
                campaign_id:this.$route.params.id,
                orderParams:{
                    filter: {
                        link_id: this.$route.params.id,
                    },
                },
                campaignStartDate: null,
                campaignEndDate: null,
                tableColumns : [],
                imagePath : getFinalPath()
            }
        },
        methods: {
            setTableColumns() {
                const baseColumns = [
                { key: 'id', sortable: true },
                { key: 'transaction', label: 'Sipariş No', sortable: true },
                { key: 'created_date', label: 'Sipariş Tarihi', sortable: true },
                { key: 'created_time', label: 'Sipariş Saati', sortable: true, tdClass: "text-center", thClass: "text-center" },
                { key: 'amount', label: 'Toplam', sortable: true },
                { key: 'order_status', label: 'Sipariş Durumu', sortable: true },
                { key: 'show_details', label: 'DETAY' },
                ];

                if (this.$route.name === 'campaign-detail') {
                // Belirli sayfada ek kolonları dahil et
                baseColumns.splice(5, 0, { key: 'inf_payment_total', label: 'Ödenecek Tutar', sortable: true })
                baseColumns.splice(6, 0, { key: 'vesting_status', label: 'Hakediş Durumu' })
                }

                this.tableColumns = baseColumns;
            },
            handleOrdersFetched(orders=null) {

               console.log(orders)

            },
            getCampaign () {
                this.$http.get('/link', {
                    params: {
                        id: this.campaign_id,
                        source: this.$route.name,
                    }
                }).then((response)=>{
                    if(response.data.success){
                        this.campaign=response.data.data.Links[0]
                        this.influencer = this.campaign.influencer
                        // Kampanya türü 0 veya 1 ise tarihleri ayarla
                        if (this.campaign.type === 0 || this.campaign.type === 1) {
                            this.campaignStartDate = this.campaign.start_date
                            this.campaignEndDate = this.campaign.end_date
                        }
                        if(this.campaign.type === 3 && this.campaign.end_date){
                            this.campaignStartDate = this.campaign.start_date
                            this.campaignEndDate = this.campaign.end_date
                        }
                    }
                    this.isLoading=false
                })
                this.setTableColumns()
            },
            
            popoverContent(image) {
            const fullUrl = this.imagePath + '/links/' + image;
            return `<img src="${fullUrl}" style='max-width: 460px; display: block;'>`;
            },
        },
        mounted () {
            this.getCampaign();
        },
    }
</script>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.b-popover {
  max-width: 500px !important; /* veya ne kadar geniş istersen */
}
</style>